// extracted by mini-css-extract-plugin
module.exports = {"giantArtwork":"GiantArtwork_giantArtwork__3c340","imageWrapper":"GiantArtwork_imageWrapper__3unSN"};